import createStyle from "@josephmark/createstyle"
import * as m from "motion/react-m"

export const Sidebar = m.create(
  createStyle(
    "aside",
    "bg-concrete border-empress/20 relative sticky top-0 z-10 flex h-screen w-[250px] flex-col overflow-hidden border-r dark:bg-black"
  )
)

export default Sidebar
